import { useState } from 'react';

interface LoadImageResult {
	error: string;
	imageSrc: string;
	width: number;
	height: number;
}

export const useImagePreview = () => {
	const [imagePreview, setImagePreview] = useState<string | ArrayBuffer | null>(
		null
	);

	const loadImage = async (file: File) => {
		let result: LoadImageResult = {
			error: '',
			imageSrc: '',
			width: 0,
			height: 0,
		};
		if (file) {
			await new Promise((resolve) => {
				const reader = new FileReader();
				reader.onloadend = (event) => {
					// result = {
					// 	error: '',
					// 	imageSrc: reader.result as string,
					// 	width: image.width,
					// 	height: image.height,
					// };
					// resolve(reader.result as string);
					const image = new Image();
					image.src = event.target?.result?.toString() || '';
					image.onload = () => {
						result = {
							error: '',
							imageSrc: reader.result as string,
							width: image.width,
							height: image.height,
						};
						resolve(reader.result as string);
					};
				};
				reader.readAsDataURL(file);
			});
		}

		return result;
	};

	const clearPreview = () => {
		setImagePreview(null);
	};

	return {
		loadImage,
		imagePreview,
		clearPreview,
	};
};
